module.exports = __webpack_public_path__ + "img/research-group-4.ab7f6e3a.jpg";